var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.447,
    height: 101.336,
    viewBox: "0 0 84.447 101.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(-3.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M74.935,94.536H4V3.333H51.29L74.935,26.978Z",
    transform: "translate(1.022 5.111)",
    fill: "#fcf05a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M78.935,88.491H8V.667H55.29L78.935,24.312Z",
    transform: "translate(7.156 1.022)",
    fill: "#fdbd40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M26.667,24.312H50.312L26.667.667Z",
    transform: "translate(35.779 1.022)",
    fill: "#f49e21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M16.4,32.045H13.023a1.689,1.689,0,0,1,0-3.378H16.4a1.689,1.689,0,0,1,0,3.378Z",
    transform: "translate(12.267 43.957)",
    fill: "#e9686a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M57.557,32.045H17.023a1.689,1.689,0,1,1,0-3.378H57.557a1.689,1.689,0,0,1,0,3.378Z",
    transform: "translate(18.401 43.957)",
    fill: "#e9686a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M16.4,28.045H13.023a1.689,1.689,0,0,1,0-3.378H16.4a1.689,1.689,0,0,1,0,3.378Z",
    transform: "translate(12.267 37.824)",
    fill: "#e9686a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M57.557,28.045H17.023a1.689,1.689,0,1,1,0-3.378H57.557a1.689,1.689,0,0,1,0,3.378Z",
    transform: "translate(18.401 37.824)",
    fill: "#e9686a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M16.4,24.045H13.023a1.689,1.689,0,1,1,0-3.378H16.4a1.689,1.689,0,0,1,0,3.378Z",
    transform: "translate(12.267 31.69)",
    fill: "#e9686a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M57.557,24.045H17.023a1.689,1.689,0,1,1,0-3.378H57.557a1.689,1.689,0,0,1,0,3.378Z",
    transform: "translate(18.401 31.69)",
    fill: "#e9686a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M16.4,20.045H13.023a1.689,1.689,0,0,1,0-3.378H16.4a1.689,1.689,0,0,1,0,3.378Z",
    transform: "translate(12.267 25.557)",
    fill: "#e9686a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M57.557,20.045H17.023a1.689,1.689,0,0,1,0-3.378H57.557a1.689,1.689,0,0,1,0,3.378Z",
    transform: "translate(18.401 25.557)",
    fill: "#e9686a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M16.4,16.045H13.023a1.689,1.689,0,1,1,0-3.378H16.4a1.689,1.689,0,0,1,0,3.378Z",
    transform: "translate(12.267 19.423)",
    fill: "#e9686a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M57.557,16.045H17.023a1.689,1.689,0,1,1,0-3.378H57.557a1.689,1.689,0,0,1,0,3.378Z",
    transform: "translate(18.401 19.423)",
    fill: "#e9686a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M12,6.667H22.134V16.8H12Z",
    transform: "translate(13.289 10.223)",
    fill: "#e9686a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M13.023,32.045H16.4a1.689,1.689,0,0,0,0-3.378H13.023a1.689,1.689,0,0,0,0,3.378Z",
    transform: "translate(12.267 43.957)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M57.557,28.667H17.023a1.689,1.689,0,1,0,0,3.378H57.557a1.689,1.689,0,0,0,0-3.378Z",
    transform: "translate(18.401 43.957)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M13.023,28.045H16.4a1.689,1.689,0,0,0,0-3.378H13.023a1.689,1.689,0,0,0,0,3.378Z",
    transform: "translate(12.267 37.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M57.557,24.667H17.023a1.689,1.689,0,1,0,0,3.378H57.557a1.689,1.689,0,0,0,0-3.378Z",
    transform: "translate(18.401 37.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M13.023,24.045H16.4a1.689,1.689,0,0,0,0-3.378H13.023a1.689,1.689,0,1,0,0,3.378Z",
    transform: "translate(12.267 31.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M57.557,20.667H17.023a1.689,1.689,0,1,0,0,3.378H57.557a1.689,1.689,0,0,0,0-3.378Z",
    transform: "translate(18.401 31.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M13.023,20.045H16.4a1.689,1.689,0,0,0,0-3.378H13.023a1.689,1.689,0,0,0,0,3.378Z",
    transform: "translate(12.267 25.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M57.557,16.667H17.023a1.689,1.689,0,0,0,0,3.378H57.557a1.689,1.689,0,0,0,0-3.378Z",
    transform: "translate(18.401 25.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M13.023,16.045H16.4a1.689,1.689,0,0,0,0-3.378H13.023a1.689,1.689,0,1,0,0,3.378Z",
    transform: "translate(12.267 19.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M15.333,14.356a1.689,1.689,0,0,0,1.689,1.689H57.557a1.689,1.689,0,0,0,0-3.378H17.023A1.689,1.689,0,0,0,15.333,14.356Z",
    transform: "translate(18.401 19.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M5.022,101.336H75.958a1.689,1.689,0,0,0,1.689-1.689V91.2h8.445a1.689,1.689,0,0,0,1.689-1.689V25.334c0-.037-.018-.069-.022-.106a1.607,1.607,0,0,0-.086-.434c-.019-.054-.032-.106-.056-.159a1.685,1.685,0,0,0-.338-.495L63.634.495a1.689,1.689,0,0,0-.495-.338c-.052-.024-.1-.037-.157-.056a1.685,1.685,0,0,0-.438-.088c-.029.005-.061-.014-.1-.014H15.156a1.689,1.689,0,0,0-1.689,1.689V6.756H5.022A1.689,1.689,0,0,0,3.333,8.445v91.2A1.689,1.689,0,0,0,5.022,101.336ZM82.014,23.645H64.135V5.766ZM16.845,3.378H60.757V25.334a1.689,1.689,0,0,0,1.689,1.689H84.4v60.8H16.845ZM6.711,10.134h6.756v79.38A1.689,1.689,0,0,0,15.156,91.2H74.269v6.756H6.711Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M13.023,19.511H23.156a1.689,1.689,0,0,0,1.689-1.689V7.689A1.689,1.689,0,0,0,23.156,6H13.023a1.689,1.689,0,0,0-1.689,1.689V17.823A1.689,1.689,0,0,0,13.023,19.511ZM14.711,9.378h6.756v6.756H14.711Z",
    transform: "translate(12.267 9.2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentFill);
export default __webpack_public_path__ + "static/media/document-fill.b4384e72941fed3253eeaba152e6e836.svg";
export { ForwardRef as ReactComponent };